@import (reference) '../../../../constants/spacing.module.less';

.expander-section {
  border-top: none;
  border-right: none;
  border-left: none;
  border-radius: @space-0;
}

.expander-content-order-details {
  display: flex;
  flex-direction: column;
  gap: @space-24;
  padding: @space-8 @space-16;
  word-break: break-word;
}
